import httpClient from '../httpClient';

export async function getArp(id: string) {
  try {
    const response = await httpClient.get(`/api/arp/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getAllArps() {
  try {
    const response = await httpClient.get(`/api/arp`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getArpsByUsuario() {
  try {
    const response = await httpClient.get(`/api/arp/arps-por-usuario`);

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter ARPs do usuário: ' + error);
  }
}

export async function getArpsDisponiveisByUsuario() {
  try {
    const response = await httpClient.get(
      `/api/arp/arps-disponiveis-por-usuario`,
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter ARPs disponíveis do usuário: ' + error);
  }
}
